import {BehaviorSubject, Subject, combineLatest} from 'rxjs';
import {filter, map, switchMap, take} from 'rxjs/operators';
import {numUtil} from '@/helper/num';
import {indexPricesCache$} from '@/streams/price-index';

export const coin$ = new BehaviorSubject('BTC');
export const amount$ = new Subject();

const indexPrice$ = coin$.pipe(
  filter((o) => o !== 'USDT'),
  switchMap((coin) =>
    indexPricesCache$.pipe(
      map((cache) => cache.get('.' + coin)),
      filter(Boolean),
      filter((o) => o.priceEp > 0),
      take(1)
    )
  )
);

export const totalAmount$ = combineLatest([indexPrice$, amount$]).pipe(map(([indexPrice, amount]) => calcTotalAmount(indexPrice.priceEp, amount, indexPrice.priceFactor)));

function calcTotalAmount(indexPriceEp, amount, priceFactor) {
  return numUtil.floor((Number(amount) * priceFactor) / indexPriceEp, 8, 0);
}
